import { get, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getAssetBasePrice = assetHierarchyId => get(`${url}/asset/asset-base-price/${assetHierarchyId}`);
const getAssetEquipments = assetHierarchyId => put(`${url}/asset/equipments`, { assetHierarchyId });

const exp = {
  getAssetBasePrice,
  getAssetEquipments
};
export default exp;
